var _circle, _circle2, _path, _path2, _path3, _line, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0001,
    cy: 20.0011,
    r: 18.5195,
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 1.14285
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 14.4286,
    fill: "white",
    stroke: "#081E54",
    strokeWidth: 1.14285
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4942 14.3235L22.6891 22.6276L18.1034 17.9334L26.4942 14.3235Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.521 25.5821L21.9991 21.8031L17.2775 17.0939L13.521 25.5821Z",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0455 17.0455L22.9545 22.9545M17.0455 17.0455L27.5 12.5L22.9545 22.9545M17.0455 17.0455L12.5 27.5L22.9545 22.9545",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.1168,
    y1: 6.02455,
    x2: 20.1168,
    y2: 8.51806,
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 33.9735,
    y1: 20.1183,
    x2: 31.48,
    y2: 20.1183,
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.1168,
    y1: 31.4816,
    x2: 20.1168,
    y2: 33.9751,
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.51988,
    y1: 20.1183,
    x2: 6.02637,
    y2: 20.1183,
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/Compass.c827d22301025883c5ab215f9b4404fb.svg";
export { ForwardRef as ReactComponent };